import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IoMenu } from "react-icons/io5";
import { AiFillCloseSquare } from "react-icons/ai";
import { MdOutlineFileDownload } from "react-icons/md";
import resume from '../../images/shakil-ahamed.pdf';
import { IoIosCloudyNight, IoIosSunny } from "react-icons/io";
import { BsFillSunriseFill } from "react-icons/bs";
import { TbSunset2 } from "react-icons/tb";


const Navbar = () => {
    const [open, setOpen] = useState(false);

    const date = new Date();
    const hour = date.getHours();

    return (
        <div className='bg-indigo-950 shadow-sm shadow-gray-400'>
            <div className=' flex justify-between items-center  text-white px-5 md:px-20 lg:px-32 py-5  max-w-[1400px] m-auto'>
                <Link className='text-xl md:text-2xl lg:text-2xl font-bold text-teal-300 animate-pulse'>Shakil</Link>

                <div className='font-bold text-xs'>
                    <p>{hour > 4 && hour < 12 && <span className='flex items-center gap-1'><BsFillSunriseFill></BsFillSunriseFill> Good Morning</span>}</p>

                    <p>{hour >= 12 && hour < 17 && <span className='flex items-center gap-1'><IoIosSunny /> Good Afternoon</span>}</p>

                    <p>{hour >= 17 && hour < 20 && <span className='flex items-center gap-1'><TbSunset2 />Good Evening</span>}</p>

                    <p>{(hour >= 20 || hour <= 4) && <span className='flex items-center gap-1'><IoIosCloudyNight></IoIosCloudyNight>Good Night</span>}</p>
                </div>

                <div onClick={() => setOpen(!open)} className='text-3xl cursor-pointer lg:hidden z-40'>
                    {
                        open ? <AiFillCloseSquare className='text-red-500'></AiFillCloseSquare> : <IoMenu />
                    }
                </div>

                <div
                    onClick={() => setOpen(!open)}
                    className={`${open ?
                        'bg-indigo-950 top-16'
                        :
                        'top-[-500px]'
                        } 
                    absolute duration-700 left-0 lg:static flex flex-col md:flex-col lg:flex-row gap-4 md:gap-10 lg:gap-10 font-medium w-full md:w-full lg:w-auto min-h-[50vh] md:min-h-[50vh] lg:min-h-0 p-20 md:p-20 lg:p-0 z-30`}>

                    <NavLink className={({ isActive }) => isActive ? 'font-bold border-b-2 border-teal-300 text-teal-300' : 'hover:text-gray-300'} to='/'>Home</NavLink>
                    <NavLink className={({ isActive }) => isActive ? 'font-bold border-b-2 border-teal-300 text-teal-300' : 'hover:text-gray-300'} to='/skills'>Skills</NavLink>
                    <NavLink className={({ isActive }) => isActive ? 'font-bold border-b-2 border-teal-300 text-teal-300' : 'hover:text-gray-300'} to='/projects'>Projects</NavLink>
                    <NavLink className={({ isActive }) => isActive ? 'font-bold border-b-2 border-teal-300 text-teal-300' : 'hover:text-gray-300'} to='/blog'>Blog</NavLink>
                    <NavLink className={({ isActive }) => isActive ? 'font-bold border-b-2 border-teal-300 text-teal-300' : 'hover:text-gray-300'} to='/about'>About</NavLink>
                    <NavLink className={({ isActive }) => isActive ? 'font-bold border-b-2 border-teal-300 text-teal-300' : 'hover:text-gray-300'} to='/contact'>Contact</NavLink>

                    <Link
                        to={resume}
                        download="Shakil-Ahamed"
                        target="_blank"
                        rel="noreferrer" className='flex items-center gap-1 btn btn-sm md:btn-xs lg:btn-xs btn-outline text-white hover:text-teal-300'>Resume <MdOutlineFileDownload className='text-xl animate-bounce'></MdOutlineFileDownload>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Navbar;